import React from 'react';
import { HeroSection } from './HeroSection';
import { PainSection } from './PainSection';
import { ProductReveal } from './ProductReveal';
import { Sistema3B } from './Sistema3B';
import { ResultsSection } from './ResultsSection';
import { IncludesSection } from './IncludesSection';
import { ForWhomSection } from './ForWhomSection';
import { CTASection } from './CTASection';
import { Footer } from './Footer';
export function SalesPage() {
  return <main className="w-full" data-id="element-245">
      <HeroSection data-id="element-246" />
      <PainSection data-id="element-247" />
      <ProductReveal data-id="element-248" />
      <Sistema3B data-id="element-249" />
      <ResultsSection data-id="element-250" />
      <IncludesSection data-id="element-251" />
      <ForWhomSection data-id="element-252" />
      <CTASection data-id="element-253" />
      <Footer data-id="element-254" />
    </main>;
}